export async function requestOpenAiData(prompt: string) {
  const apiBaseUrl = process.env.PARCEL_API_URL || "";
  // Prevent double slashes in the URL
  const endpointPath = "/api/prompt-player-data";
  // Always expect endpointPath to start with '/'
  const url = `${apiBaseUrl}${endpointPath}`;
  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ prompt }),
  });
  const data = await response.json();
  return data;
}
